import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import {
  isChunkLoadError,
  reloadOnceForStaleChunk,
} from './app/shared/error-handling/chunk-load-error';

// Global safety net for stale-chunk failures that escape Angular's
// own error pipeline (e.g. a lazy import rejection triggered by a
// non-router code path, or an unhandled promise rejection from an
// already-running bundle). One reload picks up the new file hashes.
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    if (isChunkLoadError(event?.error ?? event?.message)) {
      reloadOnceForStaleChunk();
    }
  });
  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event?.reason)) {
      event.preventDefault();
      reloadOnceForStaleChunk();
    }
  });
}

bootstrapApplication(App, appConfig).catch((err) => {
  if (isChunkLoadError(err)) {
    reloadOnceForStaleChunk();
    return;
  }
  if (!environment.production) {
    console.error(err);
  }
});
